// Environment-based configuration
const ENV_CONFIG = {
  development: {
    ISI_API_URL: "https://isi-data-dev.isilive.ca/",
    // No backup API host in dev (blank disables the failover interceptor).
    ISI_API_BACKUP_URL: "",
    ISI_RTMP_INPUT_DOMAIN: "stream-dev.isilive.ca",
    ISI_PLAYER_DOMAIN: "video-dev.isilive.ca",
    SP2_PLAYER_DOMAIN: "player2.isilive.ca",
    SP2_PLAYER_SCRIPT_URL:
      "https://static.isilive.ca/sp2_player/dev/sp2_player.debug.js",
    // Public download host (archive files + SP2 asset mp4s). Dev shares the
    // testing host — same archive, shared dev+testing DynamoDB account.
    ARCHIVE_DOWNLOAD_DOMAIN: "archive-testing.isilive.net",
    ISI_HLS_URL: "https://isi-data-dev.isilive.ca/",
    AUTH_UI_URL: "https://auth-dev.isilive.ca",
    // isi_video staff console (separate app, watch*.isilive.net). Locally it
    // runs on port 3001; there is no deployed dev host.
    ISI_VIDEO_ADMIN_URL: "http://localhost:3001",
    DISPATCHER_URL: "https://encode-dispatcher-a-dev.isilive.ca/",
  },
  testing: {
    ISI_API_URL: "https://sp2api2.isilive.ca/",
    // Standalone single-host isi_data in its own DNS/routing pool (OVH BHS).
    // A subdomain of the API host so the isi_token cookie (Domain=
    // sp2api2.isilive.ca) is sent to it too. See utils/apiFailover.js.
    ISI_API_BACKUP_URL: "https://backup.sp2api2.isilive.ca/",
    ISI_RTMP_INPUT_DOMAIN: "stream2.isilive.ca",
    ISI_PLAYER_DOMAIN: "video2.isilive.ca",
    SP2_PLAYER_DOMAIN: "player2.isilive.ca",
    SP2_PLAYER_SCRIPT_URL:
      "https://static.isilive.ca/sp2_player/testing/sp2_player.js",
    ARCHIVE_DOWNLOAD_DOMAIN: "archive-testing.isilive.net",
    ISI_HLS_URL: "https://sp2hls2.isilive.ca/",
    AUTH_UI_URL: "https://auth2.isilive.ca",
    ISI_VIDEO_ADMIN_URL: "https://watch-admin2.isilive.net",
    DISPATCHER_URL: "https://encode-dispatcher-a2.isilive.ca/",
  },
  production: {
    ISI_API_URL: "https://sp2api.isilive.ca/",
    // Standalone single-host isi_data in its own DNS/routing pool (OVH BHS),
    // subdomain of the API host so the isi_token cookie reaches it.
    ISI_API_BACKUP_URL: "https://backup.sp2api.isilive.ca/",
    ISI_RTMP_INPUT_DOMAIN: "stream.isilive.ca",
    ISI_PLAYER_DOMAIN: "video.isilive.ca",
    SP2_PLAYER_DOMAIN: "player.isilive.ca",
    // ALWAYS the rolling /latest/ alias, never a pinned version. This URL
    // is both what the console's own preview loader fetches
    // (SP2Player.create, v2.8.0+) and what the copyable embed snippets hand
    // to customers — a pasted snippet lives on their page for years and
    // must pick up player fixes without a re-paste. A stale v2.8.0 pin here
    // once left every file-browser embed silently dead in production
    // (file_name addressing only exists from v2.9.0). static.isilive.ca is
    // the canonical player CDN (Bunny -> static_origin shim; CNAME to the
    // static.isilive.net twin).
    SP2_PLAYER_SCRIPT_URL:
      "https://static.isilive.ca/sp2_player/latest/sp2_player.js",
    ARCHIVE_DOWNLOAD_DOMAIN: "archive.isilive.net",
    ISI_HLS_URL: "https://sp2hls.isilive.ca/",
    AUTH_UI_URL: "https://auth.isilive.ca",
    ISI_VIDEO_ADMIN_URL: "https://watch-admin.isilive.net",
    DISPATCHER_URL: "https://encode-dispatcher-a.isilive.ca/",
  },
};

// Determine environment based on hostname
function getEnvironment() {
  const hostname = window.location.hostname;

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("admin-dev.isilive.ca")
  ) {
    return "development";
  } else if (hostname.includes("admin2.isilive.ca")) {
    return "testing";
  } else {
    return "production";
  }
}

const currentEnv = getEnvironment();
const config = ENV_CONFIG[currentEnv] || ENV_CONFIG.production;

export const ISI_API_URL = config.ISI_API_URL;
export const ISI_API_BACKUP_URL = config.ISI_API_BACKUP_URL;
export const ISI_RTMP_INPUT_DOMAIN = config.ISI_RTMP_INPUT_DOMAIN;
// SRT ingest shares the RTMP ingest DNS names (protocol-agnostic multi-A) but
// on its own UDP port. Uniform across environments.
export const ISI_SRT_INGEST_PORT = 9001;
export const ISI_PLAYER_DOMAIN = config.ISI_PLAYER_DOMAIN;
export const SP2_PLAYER_DOMAIN = config.SP2_PLAYER_DOMAIN;
export const SP2_PLAYER_SCRIPT_URL = config.SP2_PLAYER_SCRIPT_URL;
export const ARCHIVE_DOWNLOAD_DOMAIN = config.ARCHIVE_DOWNLOAD_DOMAIN;
export const ISI_HLS_URL = config.ISI_HLS_URL;
export const AUTH_UI_URL = config.AUTH_UI_URL;
export const ISI_VIDEO_ADMIN_URL = config.ISI_VIDEO_ADMIN_URL;
//export const DISPATCHER_URL = config.DISPATCHER_URL;

// Export environment for debugging
export const CURRENT_ENV = currentEnv;

// Browser-tab title prefix so each environment is distinguishable. Production
// gets no prefix; dev and testing are tagged so they can't be confused.
const TITLE_PREFIXES = {
  development: "[dev] ",
  testing: "[test] ",
  production: "",
};
export const TITLE_PREFIX = TITLE_PREFIXES[currentEnv] || "";

// prod asuigtcfbv.us-east-1.awsapprunner.com
// dev sidnipn4iu.us-east-1.awsapprunner.com

//d-0odbhelhma.execute-api.ca-central-1.amazonaws.com
